// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grouped-row-card[data-v-510458f4] {\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n}\n.grouped-row-voucher[data-v-510458f4] {\n  background-color: #EBF1EE;\n  border-radius: 4px 4px 0 0;\n}\n.grouped-row-callout[data-v-510458f4] {\n  border-radius: 0 0 6px 6px !important;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  margin-bottom: 20px;\n}", ""]);
// Exports
module.exports = exports;
